module.exports = __webpack_public_path__ + "static/Hadozee_DND3_5_SW-5c8846419db67325f586b24d77279e4d.webp";